import {createHookDefinition} from '../../utils/hooksUtils'
import type {HookEventData} from '../hooks/hooks'

export interface SiteSavedHook extends HookEventData<'SITE_SAVED'> {
    isSaveFromDraft: boolean
}

export const SAVE_HOOKS = {
    SITE_SAVED: createHookDefinition<'SITE_SAVED', SiteSavedHook>('SITE_SAVED')
}
